


























import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { Markup } from '@/dto/deliveries/Markup'
import MarkupStore from '@/stores/MarkupStore'

@Component
export default class MarkupsTableRow extends Vue {
  @Prop(Object) markup: Markup
  @Prop(Object) props: any
  @Prop(String) currencySymbol: string

  percent = ''
  rub = ''

  get label(): string {
    return `Добавочная стоимость ${this.currencySymbol}`
  }

  savePercent(value: string) {
    this.markup.valuePercent = parseInt(value)
    this.save()
  }

  saveRub(value: string) {
    this.markup.valueRub = parseInt(value)
    this.save()
  }

  save() {
    MarkupStore.save(this.markup)
  }

  get valuePercent(): string {
    return this.markup.valuePercent + '%'
  }

  get valueRub(): string {
    return this.markup.valueRub.toLocaleString() + ` ${this.currencySymbol}`
  }

  get isBase(): boolean {
    return this.markup.project.toLowerCase() === 'базовая'
  }

  @Watch('markup', { immediate: true })
  updateValues() {
    this.percent = this.markup.valuePercent.toString()
    this.rub = this.markup.valueRub.toString()
  }
}
